const environment = process.env.REACT_APP_ENV

const appApiUrl =
  environment === 'development'
    ? process.env.REACT_APP_API_URL_DEV
    : process.env.REACT_APP_API_URL_PROD

export default appApiUrl
